import Div from "@jumbo/shared/Div";
import {
    Autocomplete,
    Box,
    Button,
    TextField,
    Typography,
} from "@mui/material";
import { fetchFinishedOrdersScrapInventory, fetchRawOrdersScrapInventory } from "app/redux/actions/inventoryAction";
import { getKcFabricCodeList } from "app/services/apis/ListApi/kcFabricCodeList";
import { getOrderNoList } from "app/services/apis/ListApi/orderNoList";
import { getRakeDetailsList } from "app/services/apis/ListApi/rakeDetailsList";
import { downloadFactoryInventoryReport } from "app/services/apis/ReportApis/FactoryInventoryReport";
import { downloadOrderFinishedScrapInventoryReport } from "app/services/apis/ReportApis/OrdersFinishedScrapInventoryReport";

import { supplierList } from "app/services/apis/supplierList";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

const OrderFinishedScrapFilter = () => {
    const [supplierNameList, setSupplierNameList] = useState([]);
    const [kcFabricCode, setKcFabricCode] = useState([]);
    const [rakeDetails, setRakeDetails] = useState([]);
    const [inputs, setInputs] = useState({});
    const [resetAutocomplete, setResetAutocomplete] = useState(false);
    const [orderNoList, setOrderNoList] = useState([]);
    const { factoryDetails, error, TotalPage } = useSelector(
        (state) => state.inventoryReducer
    );
    const dispatch = useDispatch();

    // const handleChange = (event) => {
    //     const name = event.target.name;
    //     const value = event.target.value;
    //     setInputs((values) => ({ ...values, [name]: value }));
    // };

    const handleFilter = () => {
        dispatch(fetchFinishedOrdersScrapInventory("", inputs, ""));
    };

    const handleClear = () => {
        dispatch(fetchFinishedOrdersScrapInventory("", "", 1));
        setInputs({});
        setResetAutocomplete((prev) => !prev);
    };

    useEffect(async () => {
        const data = await supplierList();
        if (data?.status === 200) {
            setSupplierNameList(data.data.result);
        }
        setKcFabricCode(await getKcFabricCodeList());
        setOrderNoList(await getOrderNoList());
        setRakeDetails(await getRakeDetailsList());
    }, []);

    return (
        <>
            <Div sx={{ display: "flex", flexWrap: "wrap", gap: 2, mt: 3 }}>
                <Div sx={{ width: "35%" }}>
                    <Typography variant="h5">Kennys Fabric Code</Typography>
                    <Autocomplete
                        key={resetAutocomplete ? "reset1" : "normal1"}
                        size="small"
                        id="tags-standard"
                        options={kcFabricCode || []}
                        getOptionLabel={(option) => option.kc_fabric_code}
                        onChange={(e, newValue) =>
                            setInputs((values) => ({
                                ...values,
                                kc_fabric_code: newValue?.kc_fabric_code
                                    ? newValue.kc_fabric_code
                                    : null,
                            }))
                        }
                        renderOption={(props, option) => (
                            <Box
                                component="li"
                                sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                                {...props}
                            >
                                {option.kc_fabric_code}
                            </Box>
                        )}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="outlined"
                            // placeholder="KC Fabric Code"
                            />
                        )}
                    />
                </Div>

                <Div sx={{ width: "35%" }}>
                    <Typography variant="h5">Rack Details</Typography>
                    <Autocomplete
                        key={resetAutocomplete ? "reset1" : "normal1"}
                        size="small"
                        id="tags-standard"
                        options={rakeDetails || []}
                        getOptionLabel={(option) => option}
                        onChange={(e, newValue) =>
                            setInputs((values) => ({
                                ...values,
                                raw_rack_details: newValue ? newValue : null,
                            }))
                        }
                        renderOption={(props, option) => (
                            <Box
                                component="li"
                                sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                                {...props}
                            >
                                {option}
                            </Box>
                        )}
                        renderInput={(params) => (
                            <TextField {...params} variant="outlined" />
                        )}
                    />
                </Div>
                <Div sx={{ width: "22%" }}>
                    <Typography variant="h5">Order No</Typography>
                    <Autocomplete
                        key={resetAutocomplete ? "reset1" : "normal1"}
                        size="small"
                        id="tags-standard"
                        options={orderNoList || []}
                        // value={}
                        getOptionLabel={(option) => option}
                        onChange={(e, newValue) =>
                            setInputs((values) => ({
                                ...values,
                                order_no: newValue ? newValue : null,
                            }))
                        }
                        renderOption={(props, option) => (
                            <Box
                                component="li"
                                sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                                {...props}
                            >
                                {option}
                            </Box>
                        )}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="outlined"
                            // placeholder="KC Fabric Code"
                            />
                        )}
                    />
                </Div>
            </Div>

            <Div
                sx={{
                    display: "flex",
                    alignItems: "center",
                    mt: 4,
                    justifyContent: "space-between",
                }}
            >
                <Div>
                    <Button
                        size="small"
                        variant="outlined"
                        sx={{ p: 1, pl: 4, pr: 4, marginRight: 2 }} // Adjust marginRight for spacing
                        onClick={handleFilter}
                    >
                        Apply
                    </Button>
                    <Button
                        size="small"
                        variant="outlined"
                        sx={{ p: 1, pl: 4, pr: 4 }}
                        onClick={handleClear}
                    >
                        Clear
                    </Button>
                </Div>
                <Button
                    disabled={factoryDetails?.length === 0}
                    variant="contained"
                    onClick={async () => {
                        const data = await downloadOrderFinishedScrapInventoryReport();
                        window.open(data);
                    }}
                >
                    Export CSV
                </Button>
            </Div>
        </>
    );
};

export default OrderFinishedScrapFilter;
